class HeaderInlineSearch {
  constructor(container) {
    this.container = container;
    this.toggle = container.querySelector('[data-header-inline-search-toggle]');
    this.input = container.querySelector('[data-header-inline-search-input]');
    this.desktopQuery = window.matchMedia('(min-width: 990px)');

    if (!this.toggle || !this.input) return;

    this.bindEvents();
  }

  bindEvents() {
    this.toggle.addEventListener('click', () => {
      if (!this.desktopQuery.matches) return;
      this.open();
    });

    this.container.addEventListener('focusin', () => {
      if (!this.desktopQuery.matches) return;
      this.open();
    });

    this.container.addEventListener('focusout', () => {
      if (!this.desktopQuery.matches) return;
      window.setTimeout(() => this.collapseIfIdle(), 0);
    });

    this.input.addEventListener('input', () => {
      if (!this.desktopQuery.matches) return;
      if (this.input.value.trim()) this.open();
    });

    document.addEventListener('click', (event) => {
      if (!this.desktopQuery.matches) return;
      if (this.container.contains(event.target)) return;
      this.collapseIfIdle();
    });

    document.addEventListener('keydown', (event) => {
      if (!this.desktopQuery.matches || event.key !== 'Escape') return;
      window.setTimeout(() => this.collapseIfIdle(), 0);
    });

    this.desktopQuery.addEventListener('change', () => {
      if (!this.desktopQuery.matches) this.resetDesktopState();
    });
  }

  open() {
    this.container.classList.add('is-expanded');
    this.toggle.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => this.input.focus(), 0);
  }

  collapseIfIdle() {
    const hasFocus = this.container.contains(document.activeElement);
    const hasText = this.input.value.trim().length > 0;

    if (!hasFocus && !hasText) {
      this.container.classList.remove('is-expanded');
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  resetDesktopState() {
    this.container.classList.remove('is-expanded');
    this.toggle.setAttribute('aria-expanded', 'false');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-header-inline-search]').forEach((container) => {
    new HeaderInlineSearch(container);
  });
});
